import React from "react";
import "./CustomColorTools.scss";

export class CustomSlider extends React.Component {
  render() {
    return <div className="Slider" />;
  }
}

export class CustomPointer extends React.Component {
  render() {
    return <div className="Pointer" />;
  }
}

export default { CustomSlider, CustomPointer };
